import { useCompany } from "#modules/company/view/useCompany";
import { getCompanyModelType } from "#modules/quoteRequestLines/helpers/getCompanyModelType";
import { PredictionModelTypeSchema } from "shared";

export const useStrategy = () => {
  const { company } = useCompany();

  const modelType = getCompanyModelType(company);

  return {
    isClustering: modelType === PredictionModelTypeSchema.enum.CLUSTERING,
    modelType,
  };
};
